module.exports = __webpack_public_path__ + "img/et-ti.ea1be59b.svg";